<template>
  <v-flex
    xs12
    :md4="mosaic"
    :lg3="mosaic"
    grow
    :style="{ 'min-height': mosaic ? '256px' : 'auto' }">
      <v-layout :column="mosaic" fill-height class="list--item" :class="{ 'condensed' : condensed }">
        <v-flex shrink>
          <v-layout
            align-center
            fill-height>
            <skeleton-loader
              v-if="bulkSelection && !mosaic"
              class="my-0 mx-2 pa-0"
              :width="24"
              :height="24"
              animation="fade"
            />
            <template v-if="mosaic">
              <skeleton-loader
                width="100%"
                :height="128"
                animation="fade"
              />
            </template>
            <template v-else-if="normal">
              <skeleton-loader
                :width="80"
                :height="80"
                animation="fade"
              />
            </template>
            <template v-else>
              <skeleton-loader
                :width="40"
                :height="40"
                animation="fade"
              />
            </template>
          </v-layout>
        </v-flex>
        <v-flex :xs12="mosaic" pa-2 class="fill-height">
          <v-layout fill-height column>
            <v-layout row >
              <v-flex class="text--item" :class="{ 'justify-center' : true, 'condensed--text': condensed }" grow>
                <skeleton-loader
                  width="100%"
                  height="20px"
                  animation="fade"
                />
              </v-flex>
            </v-layout>
            <v-flex shrink v-show="!condensed" align-self-baseline>
              <skeleton-loader
                class="d-inline-block"
                :width="100"
                :height="15"
                animation="fade"
                rounded
              />
              <skeleton-loader
                v-if="!mosaic"
                class="d-inline-block ml-2"
                :width="100"
                :height="15"
                animation="fade"
                rounded
              />
              <skeleton-loader
                class="d-inline-block ml-2"
                v-if="!mosaic"
                :width="100"
                :height="15"
                animation="fade"
                rounded
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
  </v-flex>
</template>
<script>
import SkeletonLoader from '@/components/skeleton/SkeletonLoader';

export default {
  components: {
    SkeletonLoader,
  },
  props: {
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    bulkSelection: {
      type: Boolean,
    },
    chips: {
      type: Array,
    },
    image: {
      type: Object,
    },
    icon: {
      type: Object,
    },
    flag: {
      type: Object,
    },
    type: String,
    id: Number,
    selectable: Boolean,
    checked: Boolean,
    normal: Boolean,
    condensed: Boolean,
    mosaic: Boolean,
    hideFlag: Boolean,
    hideChips: Boolean,
    params: {
      type: Array,
    },
  },
};
</script>
